import { BookMarked, Building2, ShieldCheck } from "lucide-react"
import type { NavigationItem } from "./types"

/**
 * Navigation configuration for the sidebar menu.
 * Обзор, партнёры, интеграции и биллинг из прототипа пока не строятся.
 * Справочники — группа с подпунктом «Специализации» (как в прототипе).
 */
export const navigationConfig: NavigationItem[] = [
	{
		id: "organizations",
		label: "navigation.organizations",
		icon: Building2,
		route: "/organizations",
	},
	{
		id: "directories",
		label: "navigation.directories",
		icon: BookMarked,
		children: [
			{
				id: "specializations",
				label: "navigation.specializations",
				route: "/specialization-catalogs",
			},
		],
	},
	{
		id: "access",
		label: "navigation.access",
		icon: ShieldCheck,
		route: "/access",
	},
]

/**
 * Default breadcrumb translation key for root path
 */
export const DEFAULT_BREADCRUMB_KEY = "navigation.organizations"
